import { Component, Input } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';
import { Order } from 'src/app/core/orders.service';

@Component({
  selector: 'app-order-details-general-buyer',
  templateUrl: './order-details-general-buyer.component.html',
  styleUrls: ['./order-details-general-buyer.component.scss'],
})
export class OrderDetailsGeneralBuyerComponent {
  @Input() order?: Order;
  constructor(private navigation_service: NavigationService) {}

  getBuyerFullName(): string {
    if (this.order) {
      const full_name = `${this.order.buyer_firstname} ${this.order.buyer_lastname}`;
      if (full_name.length > 30) {
        return full_name.slice(0, 27) + '...';
      } else {
        return full_name;
      }
    } else {
      return '-';
    }
  }

  getFormattedPhone(): string {
    if (!this.order?.buyer_phone) {
      return '-';
    }

    return this.order?.buyer_phone.prefix + ' ' + this.order?.buyer_phone.value;
  }

  onChatClick(): void {
    const phone_number = `${this.order?.buyer_phone?.prefix}${this.order?.buyer_phone?.value}`.replace(/\s/g, '');
    const whatsapp_url = `https://wa.me/${phone_number}`;
    window.open(whatsapp_url, '_blank');
  }

  onDetailsClick(buyer_id: string): void {
    this.navigation_service.toBuyerDetails(buyer_id);
  }
}
